<template>
  <v-dialog
    v-model="showWindow"
    scrollable
    max-width="1000"
    max-height="90%"
    min-width="600px"
  >
    <v-card
      height="100%"
      class="pa-2"
      :loading="!isFetchedOrder"
    >
      <v-form ref="inspectionReportForm" id="print" v-if="isFetchedOrder && order && order.inspection_report">
        <div class="only-for-print">
          <h1>{{ $t(`inspectionReportForm.act`) }}</h1>
        </div>
        <v-row class="fill-height ma-0 pa-0">
          <!-- order info--->
          <v-col xs="12" lg="12" md="12">
            <h3>{{ $t("viewOrdersForm.title") }} {{ order.human_number }}:</h3>
            <v-divider class="my-4"></v-divider>
            <v-row ma-0 pa-0>
              <v-col cols="4">
                <span class="text-caption grey--text text-no-wrap d-block">{{
                  $t("common.customer")
                }}</span>
                <span
                  v-if="order.customer && order.customer.is_company == 1"
                  class="d-block"
                >
                  {{
                    order.customer.is_company !== 1
                      ? "[" + order.customer.legal_name + "]"
                      : ""
                  }}
                </span>
                <span v-if="order.customer" class="d-block"
                  >{{ order.customer.last_name }}
                  {{ order.customer.first_name }}
                  {{ order.customer.patronymic }}</span
                >
                <span v-else>
                  {{ $t("viewOrders.customer_is_deleted") }}
                </span>
                <span class="d-block">{{
                  order.customer && order.customer.customer_type
                    ? order.customer.customer_type.name
                    : ""
                }}</span>
              </v-col>
              <v-col cols="4" >
                <span class="text-caption grey--text text-no-wrap d-block"
                  >{{ $t("common.contacts") }}:</span
                >
                <a v-if="order.customer" :href="'mailto:' + order.customer.email" class="d-block">{{
                  order.customer.email
                }}</a>
                <span v-if="order.customer">{{ order.customer.phone }}</span>
              </v-col>
              <v-col cols="4">
                <span class="text-caption grey--text text-no-wrap d-block"
                  >{{ $t("common.car") }}:</span
                >
                {{ order.car ? order.car.name : "" }}
                <beauty-car-number
                  v-if="order.car && order.car.car_number"
                  :number="order.car.car_number"
                  class="d-inline-block beauty-car-number"
                />
                <div class="only-for-print" v-if="order.inspection_report">
                  <strong>{{ $t('common.mileage') }}:</strong> {{ order.inspection_report.mileage }}<br/>
                  <strong>{{ $t('inspectionReportForm.vehicle_type') }}:</strong> {{ $t(`inspectionReportForm.vehicleTypes.${order.inspection_report.vehicle_type.type}`) }}
                </div>
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <v-row ma-0 pa-0>
              <v-col cols="6">
                <span class="text-caption grey--text text-no-wrap d-block">{{
                  $t("inspectionReportForm.damage_types")
                }}</span>
                <span
                  v-for="(damage, index) in damages"
                  :key="index"
                  class="pr-2"
                >
                  <span
                    class="mark markInList"
                    :style="{ backgroundColor: damage.color }"
                  >
                    {{
                      $t(`inspectionReportForm.damages.${damage.type}`).charAt(
                        0
                      )
                    }}
                  </span>
                  <span class="pl-5 ml-2 markInListTitle">{{
                    $t(`inspectionReportForm.damages.${damage.type}`)
                  }}</span>
                </span>
              </v-col>
              <v-col cols="3">
                <span class="text-caption grey--text text-no-wrap d-block">{{
                  $t("inspectionReportForm.fuel_level")
                }}</span>
                <div class="d-flex align-center">
                  <div class="text-right no-print">E</div>
                  <div v-if="order.inspection_report">
                    <v-rating v-model="order.inspection_report.fuel" clearable>
                      <template v-slot:item="props">
                        <span
                          @click="props.click"
                          class="d-inline-block mx-1 pointer rounded-sm"
                          :style="{ width: '15px' }"
                          :class="{
                            green: props.isFilled,
                            'lighten-2 grey': !props.isFilled,
                          }"
                          style="height: 30px"
                        >
                        </span>
                      </template>
                    </v-rating>
                  </div>
                  <div class="text-left no-print">F</div>
                </div>
              </v-col>
              <v-col cols="3">
                <v-select
                  :label="$t('inspectionReportForm.vehicle_type')"
                  :items="vehicleTypes"
                  v-model="order.inspection_report.vehicle_type"
                  class="pointer no-print"
                  item-text="type"
                  outlined
                  return-object
                >
                  <template v-slot:selection="{ item }">
                    {{ $t(`inspectionReportForm.vehicleTypes.${item.type}`) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ $t(`inspectionReportForm.vehicleTypes.${item.type}`) }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <div
              style="
                position: relative;
                max-width: 627px;
                min-width: 500px;
                margin: 0 auto;
              "
            >
              <img
                class="pointer"
                ref="carImg"
                :src="
                  (order.inspection_report &&
                    order.inspection_report.vehicle_type &&
                    order.inspection_report.vehicle_type.img) ||
                  null
                "
                @click="showMenu"
                style="width: 100%"
              />

              <div
                v-if="
                  order.inspection_report &&
                  order.inspection_report.marks &&
                  order.inspection_report.marks.length
                "
                v-for="mark in order.inspection_report.marks"
                class="mark pointer"
                :style="{
                  top: mark.top + '%',
                  left: mark.left + '%',
                  backgroundColor: damageColor(mark.type),
                }"
                @click="showMenu($event, mark)"
              >
                {{ $t(`inspectionReportForm.damages.${mark.type}`).charAt(0) }}
              </div>
            </div>
          </v-col>
          <v-col cols="8" class="pb-0 mb-0">
            <v-select
                class="no-print"
              outlined
              :items="paintworkDefects"
              :label="$t('inspectionReportForm.paintwork_defects_title')"
              return-object
              item-text="type"
              v-model="order.inspection_report.paintwork_defect"
            >
              <template v-slot:selection="{ item }">
                {{ $t("inspectionReportForm.paintwork_defects." + item.type) }}
              </template>
              <template v-slot:item="{ item }">
                {{ $t("inspectionReportForm.paintwork_defects." + item.type) }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="4" class="pb-0 mb-0">
            <v-text-field
                class="no-print"
              outlined
              :label="$t('common.mileage')"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
                (v) =>
                  v >= 1 || $t('form.validationErrors.must_be_greater', [0]),
              ]"
              v-model="order.inspection_report.mileage"
            >
            </v-text-field>
          </v-col>
          <v-col xs="12" class="pt-0 mt-0 no-print">
            <v-textarea
              outlined
              class="no-print"
              :label="$t('inspectionReportForm.special_marks')"
              v-model="order.inspection_report.special_marks"
            >
            </v-textarea>
            <v-combobox
              hide-details
              outlined
              v-if="order.inspection_report"
              v-model="order.inspection_report.equipments"
              :items="equipments"
              chips
              clearable
              item-text="type"
              :label="$t('inspectionReportForm.equipments_title')"
              multiple
            >
              <template v-slot:item="{ item, on, attrs, select }">
                <v-simple-checkbox
                  @click="
                    attrs['aria-selected'] == 'true'
                      ? removeEquipmentFromInspectionReport(item)
                      : order.inspection_report.equipments.push(item)
                  "
                  :value="attrs['aria-selected'] == 'true'"
                ></v-simple-checkbox>
                {{ $t("inspectionReportForm.equipments." + item.type) }}
              </template>
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  @click="select"
                  @click:close="removeEquipmentFromInspectionReport(item)"
                >
                  <strong>{{
                    $t("inspectionReportForm.equipments." + item.type)
                  }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-col xs="12" lg="12" md="12" class="text-right no-print">
            <v-divider class="mb-6"></v-divider>
            <!--<v-btn class="mb-4 mr-2" depressed color="primary" :href="`${$apiURL}/orders/${order.id}/inspection-report`" target="_blank">-->
            <v-btn class="mb-4 mr-2" depressed color="primary" @click="print" :disabled="!order.inspection_report">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
            <v-btn
              class="mb-4 white--text"
              depressed
              color="primary"
              @click="orderUpdate"
              :loading="savingInProgress"
              :disabled="savingInProgress"
              >{{ $t("common.save") }}
            </v-btn>
          </v-col>
        </v-row>
        <div class="only-for-print" v-if="order.inspection_report">
          <v-row>
            <v-col>
              <template v-if="order.inspection_report.paintwork_defect">
                <strong>{{ $t('inspectionReportForm.paintwork_defects_title') }}:</strong> {{ $t(`inspectionReportForm.paintwork_defects.${order.inspection_report.paintwork_defect.type}`) }}<br/>
              </template>
              <template v-if="order.inspection_report.special_marks">
              <strong>{{ $t('inspectionReportForm.special_marks') }}:</strong> {{ order.inspection_report.special_marks }}<br/>
              </template>
              <strong>{{ $t('inspectionReportForm.equipments_title') }}:</strong>
              <template v-if="order.inspection_report.equipments && order.inspection_report.equipments.length>0">
                <span v-for="equipment in order.inspection_report.equipments">
                  {{ $t("inspectionReportForm.equipments." + equipment.type) }},
                </span>
              </template>
              <template v-else>
                -
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p>{{ $t(`inspectionReportForm.i_agree`) }}</p>
              <p><br />_________________________________</p>
            </v-col>
            <v-col cols="6" class="text-right">
              <p>{{ $t(`common.date_time`) }}: {{ currentDateTime }}</p>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-card>

    <v-menu
      v-model="menuIsVisible"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item v-for="(damage, index) in damages" :key="index">
          <v-list-item-title @click="addMark(damage)" class="pointer">
            <span
              class="mark d-inline-block"
              :style="{ backgroundColor: damage.color }"
              >{{
                $t(`inspectionReportForm.damages.${damage.type}`).charAt(0)
              }}</span
            >
            <span class="pl-5 ml-2">{{
              $t(`inspectionReportForm.damages.${damage.type}`)
            }}</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="markForEdit">
          <v-list-item-title @click="removeMark" class="pointer">
            <span
              class="mark d-inline-block"
              :style="{ backgroundColor: 'gray' }"
              >X</span
            >
            <span class="pl-5 ml-2">{{ $t(`common.remove`) }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "../common/BeautyCarNumber";

export default {
  name: "InspectionReportForm",
  mixins: [CommonMixin],
  components: {
    BeautyCarNumber,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: Number,
      default: false,
    },
  },
  data: () => ({
    left: 0,
    top: 0,
    x: 0,
    y: 0,
    height: 0,
    width: 0,
    menuIsVisible: false,
    markForEdit: null,
    colors: {},
    order: null
  }),
  mounted() {
    if (!this.inspectionReportDataIsFetched)
      this.$store.dispatch("order_inspection_reports/inspectionReportsDataGet");
  },
  computed: {
    ...mapFields("order_inspection_reports", [
      "inspectionReportDataIsFetched",
      "paintworkDefects",
      "equipments",
      "vehicleTypes",
      "damages",
      "emptyInspectionReport",
    ]),
    ...mapFields("orders", [
      "imageLoading",
      "comment",
      "isFetchedOrder",
      "savingInProgress",
    ]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
    currentDateTime() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      let hours = today.getHours();
      let minutes = today.getMinutes();
      return `${dd}.${mm}.${yyyy} ${hours}:${minutes}`;
    },
  },
  methods: {
    async print () {

      // Pass the element id here
      await this.$htmlToPaper('print', {
        styles: [
          '/inspectionForm.css'
        ]
      });
    },
    damageColor(type) {
      return this.damages.filter((d) => d.type === type)[0].color;
    },
    async orderUpdate() {
      if (this.$refs["inspectionReportForm"].validate()) {
        this.$store
          .dispatch("orders/ordersUpdate", this.order)
          .then(async (res) => {
            if (!res)
              this.order = await this.$store.dispatch("orders/orderShow", { id: this.order.id });
          });
      }
    },
    removeEquipmentFromInspectionReport(item) {
      this.order.inspection_report.equipments =
        this.order.inspection_report.equipments.filter(
          (cur) => cur.type != item.type
        );
    },
    addMark(item) {
      if (!this.markForEdit) {
        this.order.inspection_report.marks.push({
          type: item.type,
          left: ((this.x - this.left - 9) / this.width) * 100,
          top: ((this.y - this.top - 10) / this.height) * 100,
        });
      } else {
        this.order.inspection_report.marks.forEach((mark) => {
          if (
            mark.left === this.markForEdit.left &&
            mark.top === this.markForEdit.top
          ) {
            mark.type = item.type;
          }
        });
      }
    },
    removeMark() {
      this.order.inspection_report.marks =
        this.order.inspection_report.marks.filter((mark) => {
          return !(
            mark.left === this.markForEdit.left &&
            mark.top === this.markForEdit.top
          );
        });
    },
    showMenu(e, mark) {
      this.markForEdit = mark || null;
      e.preventDefault();
      this.menuIsVisible = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.left = this.$refs.carImg.getBoundingClientRect().left;
      this.top = this.$refs.carImg.getBoundingClientRect().top;
      this.height = this.$refs.carImg.height;
      this.width = this.$refs.carImg.width;
      this.$nextTick(() => {
        this.menuIsVisible = true;
      });
    },
  },
  watch: {
    inspectionReportDataIsFetched(to, from) {
      if (
        to === true &&
        this.order &&
        this.order.inspection_report &&
        !this.order.inspection_report.vehicle_type
      ) {
        this.order.inspection_report.vehicle_type = this.vehicleTypes[0];
      }
    },
    async showWindow(to) {
      if (to) {
        await this.$store.dispatch("orders/orderShow", { id: this.orderId }).then(async (order)=>{
          this.order = order;
          if (!this.order.inspection_report) {
            this.order.inspection_report = JSON.parse(
              JSON.stringify(this.emptyInspectionReport)
            );
            if (
              this.vehicleTypes.length &&
              !this.order.inspection_report.vehicle_type
            ) {
              this.order.inspection_report.vehicle_type = this.vehicleTypes[0];
            }
          }
        })
      }
    },
  },
};
</script>
<style type="css">
.mark {
  position: absolute;
  height: 19px;
  width: 19px;
  text-align: center;
  border-radius: 10px;
  color: white;
  font-size: 12px;
  line-height: 18px;
  padding-top: 1px;
  display: inline-block;
}
.only-for-print {
  display: none !important;
}
</style>
